import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DoctorFeedbackComponent } from './doctor-feedback/doctor-feedback.component';
import { PastMedicalHistoryComponent } from './past-medical-history/past-medical-history.component';
import { PatientBasicDetailsComponent } from './patient-basic-details/patient-basic-details.component';
import { PatientvMessageCentreComponent } from './patientv-message-centre/patientv-message-centre.component';
import { PatientviewComponent } from './patientview/patientview.component';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { DocumentViewerComponent } from '../document-viewer/document-viewer.component';
import { MedicalReportsComponent } from './medical-reports/medical-reports.component';
import { PrescriptionDetailsComponent } from '../prescription-details/prescription-details.component';
import { DoctorreportpdfComponent } from '../doctorreportpdf/doctorreportpdf.component';
import { EglobaldoctorsConultationsComponent } from './eglobaldoctors-conultations/eglobaldoctors-conultations.component';
import { MedicalHistoryUiEditComponent } from '../medical-history-ui-edit/medical-history-ui-edit.component';
import { UtilitiesModule } from '../utilities/utilities.module';
import { DietConsultationDataComponent } from './diet-consultation-data/diet-consultation-data.component';
import { OtpInputComponent } from '../otp-input/otp-input.component';

// import { LoadingComponent } from '../utilities/loading/loading.component';

const components = [
    PatientviewComponent,
    DoctorFeedbackComponent,
    PastMedicalHistoryComponent,
    PatientBasicDetailsComponent,
    PatientvMessageCentreComponent,
    DocumentViewerComponent,
    MedicalReportsComponent,
    DoctorreportpdfComponent,
    PrescriptionDetailsComponent,
    EglobaldoctorsConultationsComponent,
    MedicalHistoryUiEditComponent,
    DietConsultationDataComponent,
    OtpInputComponent
    // LoadingComponent,
];

@NgModule({
    declarations: components,
    imports: [CommonModule, PrimengModule, UtilitiesModule],
    exports: components
})
export class PatientViewModule {}
